import { useMemo } from "react";
import { createTheme } from "@mui/material/styles";
import paletteLight from "./PaletteLight";
import { useRecoilState, useRecoilValue } from "recoil";
import { muiThemeMode } from "themes/atom";
import paletteDark from "./PaletteDark";
import { deDE } from "@mui/material/locale";
import { deDE as dedDate } from "@mui/x-date-pickers/locales";
// eslint-disable-next-line import/no-extraneous-dependencies
import { deDE as dedeGrid, enUS, esES } from "@mui/x-data-grid/locales";

import { languageAtom } from "translations/recoilState";

const commonTheme = {
  typography: { fontFamily: "Roboto", fontSize: 16 },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1500,
    },
  },
};

const lightTheme = createTheme(
  {
    ...commonTheme,
    palette: paletteLight,
  },
  dedeGrid,
  dedDate,
  deDE
);
const darkTheme = createTheme(
  {
    ...commonTheme,
    palette: paletteDark,
  },
  dedeGrid,
  dedDate,
  deDE
);

export const useCustomThemeManager = () => {
  const [mode, setMode] = useRecoilState<string>(muiThemeMode);
  const language = useRecoilValue(languageAtom);
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    [setMode]
  );

  const themePre = mode === "light" ? lightTheme : darkTheme;
  const theme = createTheme(themePre, language === "DE" ? dedeGrid : language === "ES" ? esES : enUS);
  return { colorMode, theme, mode };
};

export default () => {
  const { theme } = useCustomThemeManager();
  return theme;
};
